<template>
  <span v-if="eventLog.stripePayment">
  Invoice
  <router-link tag="a" :to="`/invoices/view/${eventLog.invoiceId}`"
    >#{{ eventLog.invoiceNumber }}</router-link
  >&nbsp;
  <div class="badge badge-pill badge-success">paid</div>
  &nbsp;online by
  <router-link
    tag="a"
    :to="`/customers/view/${eventLog.customerId}`"
    >{{ eventLog.customerName }}</router-link
  >&nbsp;with a total of
  <strong>{{ eventLog.total }}</strong>
</span>
<span v-else>
  Invoice
  <router-link tag="a" :to="`/invoices/view/${eventLog.invoiceId}`"
    >#{{ eventLog.invoiceNumber }}</router-link
  >&nbsp;marked as
  <div class="badge badge-pill badge-success">paid</div>
  &nbsp;with a total of
  <strong>{{ eventLog.total }}</strong>
</span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionInvoicePaid',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
